import { animate, state, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-chat-scroll-button',
  standalone: true,
  imports: [CommonModule, MatIcon, MatIconButton],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './chat-scroll-button.component.html',
  styleUrls: ['./chat-scroll-button.component.scss'],
  animations: [
    trigger('fadeIn', [
      state('void', style({ opacity: 0, visibility: 'hidden' })),
      state('*', style({ opacity: 1, visibility: 'visible' })),
      transition(':enter', [animate('0.3s ease-in', style({ opacity: 1, visibility: 'visible' }))]),
      transition(':leave', [animate('0.3s ease-out', style({ opacity: 0, visibility: 'hidden' }))]),
    ]),
  ],
})
export class ChatScrollButtonComponent {
  /**
   * Controls whether the button is visible
   */
  @Input() visible = false;

  /**
   * Icon to display in the button
   */
  @Input() icon = 'keyboard_arrow_down';

  /**
   * Accessibility label for screen readers
   */
  @Input() ariaLabel = 'Scroll to bottom';

  /**
   * Tooltip text for the button
   */
  @Input() title = 'Scroll to bottom';

  /**
   * Event emitted when the scroll button is clicked
   */
  @Output() scrollClick = new EventEmitter<void>();

  /**
   * Handles button click and emits the scrollClick event
   */
  onScrollClick(): void {
    this.scrollClick.emit();
  }
}